import Immutable, { Map } from "immutable";
import Serialize from "remotedev-serialize";

const { stringify, parse } = Serialize.immutable(Immutable);

//const endpoint = "https://cfc.reliability.com";
const endpoint = "";

export const debounce = (f, millis) => {
  let id;
  return (...args) => {
    if (id) {
      clearTimeout(id);
    }
    id = setTimeout(() => f(...args), millis);
  };
};

export const throttle = (f, millis) => {
  let then = 0;
  return (...args) => {
    const now = Date.now();
    if (now - then > millis) {
      f(...args);
      then = now;
    }
  };
};

const putState = (state, callback) => {
  fetch(`${endpoint}/state/${state.get("uuid")}`, {
    method: "PUT",
    mode: "cors",
    headers: { "Content-Type": "application/json" },
    body: stringify(state),
  })
    .then(res => {
      if (res.status === 200) {
        callback(null, state);
      } else {
        callback(res.status, null);
      }
    })
    .catch(err => {
      callback(err, null);
    });
};

export const getState = (uuid, callback) => {
  fetch(`${endpoint}/state/${uuid}`)
    .then(res => {
      if (res.status === 200) {
        res.text().then(t => callback(null, parse(t)));
      } else {
        callback(res.status, null);
      }
    })
    .catch(err => {
      console.error(err);
      callback(500, null);
    });
};

const wrapUpdates = reducer => {
  return (state, action) => {
    const newState = reducer(state, action);
    if (action.type !== "UPDATE_STATE") {
      putState(newState, (err, res) => {
        if (err) {
          console.error(`failed to update state: ${err}`);
        }
      });
    }
    return newState;
  };
};

export const reducer = wrapUpdates((state, action) => {
  switch (action.type) {
    case "ADD_EQUIPMENT":
      return state
        .update("equipment", eq => eq.add(action.equipment))
        .updateIn(["expenses", action.equipment], null, x => (!x ? Map() : x));
    case "DEL_EQUIPMENT":
      return state
        .deleteIn(["equipment", action.equipment])
        .deleteIn(["expenses", action.equipment]);
    case "DEL_PART":
      return state.deleteIn(["expenses", action.equipment, action.part]);
    case "ADD_PART":
      return state.updateIn(
        ["expenses", action.equipment, action.part],
        null,
        x => (!x ? Map() : x),
      );
    case "ADD_PART_ATTR": {
      const { equipment, part, attribute, value } = action;
      const x = state.setIn(["expenses", equipment, part, attribute], value);
      return x;
    }
    case "UPDATE_STATE":
      return action.state;
    default:
      console.error(`undefined reducer state: ${state}`);
      return state;
  }
});
